import { render } from "./FacilityAdminDashboardLayout.vue?vue&type=template&id=0d46016e"
import script from "./FacilityAdminDashboardLayout.vue?vue&type=script&lang=js"
export * from "./FacilityAdminDashboardLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__